import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { deleteAbout, getAbouts } from '../../../../../api/endpoints/cmsSite';
import type { About } from '../../../../../api/types/cmsSite';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';
import {
  ListPageScaffold,
  RowActions,
  useDeleteResource,
  type DataTableColumn,
} from '../../../../../components/common';
import { AboutFormDialog } from '../AboutFormDialog';

export default function AboutListPage({ siteId }: { siteId: number }) {
  const [createOpen, setCreateOpen] = useState(false);
  const [editing, setEditing] = useState<About | null>(null);

  const query = useQuery({ queryKey: ['cms', 'abouts', siteId], queryFn: () => getAbouts(siteId) });
  const rows: About[] = useMemo(() => query.data?.abouts ?? [], [query.data]);

  const del = useDeleteResource<number>({
    mutationFn: (id) => deleteAbout(id),
    invalidateKeys: [['cms', 'abouts']],
    successMessage: 'Hakkımızda kaydı silindi.',
  });

  const columns: DataTableColumn<About>[] = [
    { id: 'title', header: 'Başlık', cell: (r) => r.title ?? '—' },
    { id: 'summary', header: 'Özet', cell: (r) => r.summary ?? '—' },
    { id: 'type', header: 'Tip', cell: (r) => r.type ?? '—' },
  ];

  return (
    <ListPageScaffold
      title="Hakkımızda"
      headerVariant="section"
      createLabel="Yeni Hakkımızda İçeriği"
      onCreate={() => setCreateOpen(true)}
      query={query}
      rows={rows}
      columns={columns}
      getRowKey={(r) => r.id}
      emptyTitle="Kayıtlı hakkımızda içeriği bulunamadı."
      rowActions={(r) => <RowActions onEdit={() => setEditing(r)} onDelete={() => del.request(r.id)} />}
    >
      <AboutFormDialog open={createOpen} about={null} siteId={siteId} onClose={() => setCreateOpen(false)} />
      <AboutFormDialog open={!!editing} about={editing} siteId={siteId} onClose={() => setEditing(null)} />
      <ConfirmDialog
        {...del.confirmDialogProps}
        title="Hakkımızda kaydını sil"
        description="Bu içeriği silmek istediğinize emin misiniz?"
      />
    </ListPageScaffold>
  );
}
